import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

const CustomInfiniteScroll = ({
  dataLength = 0,
  hasMore = false,
  next,
  children,
  scrollableTarget = 'custom-infinite-scroll',
  scrollThreshold = 0.8,
  containerStyle = { maxHeight: '385px', overflow: 'auto' }
}) => {
  return (
    <div
      id={scrollableTarget}
      style={containerStyle}
    >
      <InfiniteScroll
        dataLength={dataLength}
        next={next}
        hasMore={hasMore}
        scrollThreshold={scrollThreshold}
        scrollableTarget={scrollableTarget}
        loader={hasMore
          ? (
            <p style={{ textAlign: 'center', marginTop: 10 }}>Loading more...</p>
            )
          : null}
      >
        {children}
      </InfiniteScroll>
    </div>
  )
}

export default CustomInfiniteScroll
